import {Component} from '@angular/core';
import { DbService } from '../_services/db.service';
import {Router} from '@angular/router';
import {MarkiererComponent} from './markierer.component';
import {AuthenticationService} from '../_services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'markierer-app',
  templateUrl: './markierer.component.html',
  styleUrls: ['../app.component.css']})

export class MarkiererDesktopComponent extends MarkiererComponent{

  constructor(
    router: Router,
    service: DbService,
    authenticationService: AuthenticationService) {
    super(router, service, authenticationService);
  }

}
